import ProfilePage from 'profile/presentation/components/profile.page'

const ProfileFactory = () => {
  return <ProfilePage />
}

export default ProfileFactory
